import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import { isNotPhoneUS, isPhoneInvalid } from 'utils/phoneHelpers';
import { TActiveTypes } from 'data/page-data/quote-data';

export type TQuoteValues = {
  firstName: string;
  lastName: string;
  companyName: string;
  phone: string;
  email: string;
  message: string;
  chose: string;
  originCity: string;
  destinationCity: string;
  deliveryDate: Date | null;
  pickupDate: Date | null;
  loadType: TActiveTypes;
};

type QuoteValues = Partial<TQuoteValues>;

export const quoteValidation = ({
  email = '',
  firstName = '',
  lastName = '',
  companyName = '',
  phone = '',
  originCity = '',
  destinationCity = '',
}: QuoteValues): QuoteValues => {
  const errors: QuoteValues = {};

  // Email
  if (!isEmail(email)) errors.email = 'Invalid Email address';
  if (isEmpty(email)) errors.email = 'Required field';

  // First Name
  if (isEmpty(firstName)) errors.firstName = 'Required field';

  // Last Name
  if (isEmpty(lastName)) errors.lastName = 'Required field';

  // Company Name
  if (isEmpty(companyName)) errors.companyName = 'Required field';

  // Phone
  if (isNotPhoneUS(phone)) errors.phone = 'Not a US phone number';
  if (isPhoneInvalid(phone)) errors.phone = 'Invalid phone number';
  if (isEmpty(phone)) errors.phone = 'Required field';

  // Origin Code
  if (isEmpty(originCity)) errors.originCity = 'Required field';

  // Destination Code
  if (isEmpty(destinationCity)) errors.destinationCity = 'Required field';

  return errors;
};
